import 'dayjs/locale/vi';

import viVN from 'antd/lib/locale/vi_VN';

import announcements from './announcements';
import common from './common';
import dashboard from './dashboard';
import device from './device';
import deviceGroup from './deviceGroup';
import facility from './facility';
import Form from './form';
import newsManagement from './newsManagement';
import notifications from './notifications';
import organizations from './organizations';
import packageManagement from './packageManagement';
import pageError from './pageError';
import pagePaymentSuccess from './pagePaymentSuccess';
import profile from './profile';
import server from './server';
import settingSystem from './settingSystem';
import sourceInformation from './sourceInformation';
import stepView from './stepView';
import tariff from './tariff';

export default {
  ...viVN,
  ...common,
  ...dashboard,
  ...pagePaymentSuccess,
  ...newsManagement,
  ...server,
  ...profile,
  ...pageError,
  ...device,
  ...organizations,
  ...tariff,
  ...sourceInformation,
  ...facility,
  ...stepView,
  ...settingSystem,
  ...notifications,
  ...announcements,
  ...packageManagement,
  ...deviceGroup,
  Form,
};
